import React from 'react';
import { connect } from 'react-redux';
import { getLocationsThunk } from 'store/mockServices/mockServiceList/mockServiceListActions';
import { ApplicationState } from 'store/rootReducer';
import { fetchServices } from 'store/services/servicesActions';
import styles from 'views/MockServices/Tabs/MockServices/Locations.module.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import { isEuClusterEnabledInPlan, isPrivateDataEnabled } from 'utils/bzmUserConfigUtil';
import BlazeInputDropdown, { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { createTransactionalLocations } from 'utils/locationUtil';
import RefreshLocationsBtn from 'components/refreshLocations/RefreshLocationsBtn';
import clsx from 'clsx';
import _ from 'lodash';
import { PROVIDER_CLOUD, PROVIDER_OPL } from '../../../../constants/bzm-constants';
import i18n from '../../../../i18n';

type LocationsProps = StateProps & DispatchProps & LocalProps & WithTranslation;
const defaultOption: BlazeDropdownItem = { name: 'Select Location', id: 0 };

export const resolvePlaceholder = (dataSize: number, locationsSettings: string) => {
  if (dataSize > 0) {
    return '';
  }

  if (_.isNil(locationsSettings)) {
    return (
      <div className="text-center" style={{ width: 250 }}>
        <div className="text-center font-weight-semi-bold">{i18n.t('common:locations.notAvailable')}</div>
        <p dangerouslySetInnerHTML={{ __html: i18n.t('common:locations.description') }}></p>
      </div>
    );
  } else {
    return (
      <div className="text-center" style={{ width: 250 }}>
        <div className="text-center font-weight-semi-bold">{i18n.t('common:locations.notAvailable')}</div>
        <p>
          <span>{i18n.t('common:locations.allowed.prefix')}</span>{' '}
          <a href={locationsSettings}>{i18n.t('common:locations.allowed.link')}</a>
          <span>{i18n.t('common:locations.allowed.sufix')}</span>
        </p>
      </div>
    );
  }
};

class Locations extends React.Component<LocationsProps> {
  componentDidMount() {
    if (!this.props.manualPreLoad) {
      if (!this.props.locData[0]) this.props.getLoc();
    }
  }

  onChangeLocation = (location: BlazeDropdownItem) => {
    this.props.onChangeLocation(location.metaData ? location.metaData : '');
  };

  getSelectedLocation = (locations: any[]) => {
    const index = locations.findIndex(item => item.id === this.props.rowData.shipId);
    if (index !== -1) {
      return locations[index];
    }
    if (this.props.selectFirstItem === true) {
      return _.first(locations);
    }
    return defaultOption;
  };

  render() {
    let locations = createTransactionalLocations(this.props.locData, isPrivateDataEnabled(this.props.blazeUserConfig));
    if (this.props.filterBy !== undefined) {
      locations = locations.filter(l => l.group === this.props.filterBy && l.metaData.isKubernetes !== true);
    }

    if (!isEuClusterEnabledInPlan()) {
      const euLocation = locations.filter(item => item.name === 'EU West (London)');
      if (euLocation !== undefined && euLocation.length > 0 && this.props.rowData.shipId !== euLocation[0].id) {
        locations = locations.filter(item => item.id !== euLocation[0].id);
      }
    }

    if (locations.length > 0 && this.props.selectFirstItem === true) {
      const first = _.first(locations);
      if (first !== undefined && this.props.exportSelected !== undefined) {
        this.props.exportSelected(first);
      }
    }

    return (
      <div className={clsx(styles.newLocationSelect, 'qa-location-picker')}>
        <BlazeInputDropdown
          id={this.props.id}
          defaultOption={defaultOption}
          disabled={this.props.locationPickerState}
          searchPlaceholder={'Search Locations...'}
          noItemsPlaceholder={resolvePlaceholder(
            locations.length,
            this.props.locSettings ? this.props.locSettings : '',
          )}
          height={150}
          selected={this.getSelectedLocation(locations)}
          showGroups={true}
          isSearchable={true}
          onClick={this.onChangeLocation}
          items={locations}
          dropDownFooter={
            <div className={'text-center'}>
              <RefreshLocationsBtn variant={'button'} />
            </div>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = ({ blazeUserConfig, mockservices }: ApplicationState) => ({
  locData: mockservices.locData,
  blazeUserConfig: blazeUserConfig.blazeUserConfig,
});

const mapDispatchToProps = {
  getLoc: getLocationsThunk,
  fetchVirtualServices: fetchServices,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
interface LocalProps {
  onChangeLocation(location: any): void;
  rowData: any;
  /** Disables the auto-loading of locations when component mounts.  Useful if this component is used in a list. */
  manualPreLoad?: boolean;
  locationPickerState?: boolean;
  selectFirstItem?: boolean;
  exportSelected?: (location: BlazeDropdownItem) => void;
  id?: string;
  filterBy?: typeof PROVIDER_CLOUD | typeof PROVIDER_OPL;
  locSettings?: string;
}

export default withTranslation('mockServices')(connect(mapStateToProps, mapDispatchToProps)(Locations));
